module.exports = {"module":"standard","path":"/zh-tw/standard/introduce","name":"聯繫我們","content":[{"type":"html","text":"歡迎使用<a href='https://bingx.com' target='_blank'>BingX</a>開發者文檔。"},{"type":"normal","text":"本文檔提供了標准合約交易業務相關API的使用方法介紹。"},{"type":"html","text":"如有問題反饋可加入：<a href='https://t.me/+uSWmuaKA5sw2MzE1' target='_blank'>API問題telegram電報群</a>"},{"type":"html","text":"BingX 誠摯邀請您參與 API 功能使用者調查，分享您的想法，以便更好地為您服務，提升您的交易體驗。<a href='https://docs.google.com/forms/d/e/1FAIpQLSd0yjx5okwQG1D7tf4pBAcf4WbMW8zE-Ew01ardWGCwoIZoMg/viewform' target='_blank'>填寫問卷</a>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/standard/1_introduce.json
// module id = okpR
// module chunks = 3